<template>
  <div>
    <vue-headful
          :title="$t('pages.about') + ' - Fernando Mata'"
        />
    <article class="post">
        <p v-html="$t('about.info')"></p>
    </article>
  </div>
</template>

<script>
export default {
  name: "About"
}
</script>
